<ng-container *ngIf="component.data$ | async as data">
  <py-header-navigation-item
    *ngIf="data.name"
    [class.d-none]="!(isAnonymous$ | async)"
    [url]="{ cxRoute: 'register' } | cxUrl"
    [disableActive]="hasActiveMenuItem$ | async"
  >
    <span class="text-nowrap">{{ 'navigation.register_title' | cxTranslate }}</span>
  </py-header-navigation-item>
</ng-container>
